<template>
  <div class="rlp">
    <h2>Articles Connexes</h2>
    <SkeletonLoading v-show="loading">
      <div class="rlp__grid">
        <SkeletonRectangle v-for="i in [1,2,3]" :key="`r1-${i}`" :width="250" :height="156"/>
        <SkeletonRectangle v-for="i in [1,2,3]" :key="`r2-${i}`" :width="250" :height="30"/>
      </div>
    </SkeletonLoading>
    <div class="rlp__grid" v-show="!loading">
      <article v-for="post in posts">
        <a :href="post.link">
          <figure v-html="post.featuredMediaHtml"></figure>
          <div>{{ decodeHTML(post.title.rendered) }}</div>
        </a>
      </article>
      <article v-for="i in missingPosts"></article>
      <div v-for="post in posts" class="rlp__date">{{ modifiedHumanDate(post) }}</div>
      <div v-for="i in missingPosts"></div>
    </div>
  </div>
</template>

<script>
import SkeletonLoading from "@/components/skeletons/SkeletonLoading"
import SkeletonRectangle from "@/components/skeletons/SkeletonRectangle"


export default {
  name: "RelatedPosts",
  components: {SkeletonRectangle, SkeletonLoading},
  data() {
    return {
      posts: [],
      loading: true,
    }
  },
  computed: {
    missingPosts() {
      if (this.posts.length < 3) {
        return [...Array(3 - this.posts.length).keys()]
      }

      return []
    },
  },
  methods: {
    modifiedHumanDate(post) {
      const date = new Date(post.date)
      const options = {year: 'numeric', month: 'long', day: 'numeric'};

      return date.toLocaleDateString('fr-FR', options)
    },
    decodeHTML(html) {
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
  },
  beforeMount() {
    this.loading = true
    new Promise(resolve => {
      resolve(JSON.parse(document.getElementById('related-posts-data').innerHTML))
    })
      .then(ids => {
        $api.get(`wp/v2/posts?include=${ids}`)
          .then(posts => this.posts = posts.data)
          .finally(() => this.loading = false)
      })
  },
}
</script>

<style lang="scss">

.rlp__grid {
  display: grid;
  grid-template-rows: 220px;
  grid-column-gap: 2%;
  grid-row-gap: 1rem;
  margin-bottom: 3rem;

  article {
    a {
      text-decoration: none;
      color: var(--dark-blue);
      line-height: 1.8rem;

      &:hover {
        color: var(--green);

        figure {
          img {
            transform: scale(1.1);
          }
        }
      }

      figure {
        max-height: 156px;
        overflow: hidden;
        margin-bottom: 1rem;

        img {
          transition: all .15s
        }
      }
    }
  }

  .rlp__date {
    margin-top: 1rem;
    color: lightslategrey;
    border-bottom: 1px solid;
  }
}

@media screen and (max-width: 499px) {
  .rlp__grid {
    .rlp__date {
      &:first-of-type {
        grid-row: 2;
      }

      &:nth-of-type(2) {
        grid-row: 4;
      }

      &:nth-of-type(3) {
        grid-row: 6;
      }
    }
  }
}

@media screen and (min-width: 500px) {
  .rlp__grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>
